// extracted by mini-css-extract-plugin
export default {"elem":"Contacts_elem__W+Zir","text":"Contacts_text__kop-x","link":"Contacts_link__Dvv9o"};